import { Injectable } from '@angular/core';
import { WrapperHttpService } from '../../../../../services/wrapper-http-service';
import { Observable } from 'rxjs';
import { API_URL } from '../../../../../../services/config';
import { Sc3FailedMessagesListSearchCriteria, Sc3FailedMessagesModel } from '../../models/sc3-failed-messages.model';
import { FailedMessagesEndpoint } from '../../constants/failed-messages-endpoint';
import { isEmpty } from 'lodash';
import { removeEmptyValueFromObj } from '../../../../../../common';

@Injectable({
  providedIn: 'root',
})
export class Sc3FailedMessagesListService {
  constructor(private http: WrapperHttpService) {}

  getSc3FailedMessagesList({
    size,
    page,
    ...rest
  }: Sc3FailedMessagesListSearchCriteria): Observable<Sc3FailedMessagesModel[]> {
    const transactionDateTime = removeEmptyValueFromObj({
      ...rest.transactionDateTime,
      start: rest.transactionDateTime?.start ? new Date(rest.transactionDateTime.start).getTime() : null,
      end: rest.transactionDateTime?.end ? new Date(rest.transactionDateTime.end).getTime() : null,
    });
    const filter = removeEmptyValueFromObj({
      ...rest,
      transactionDateTime: isEmpty(transactionDateTime) ? null : transactionDateTime,
    });
    const url = `${API_URL}${FailedMessagesEndpoint.Base}${FailedMessagesEndpoint.Sc3}${FailedMessagesEndpoint.FailedTransaction}?`;
    return this.http.withLoading().post<Sc3FailedMessagesModel[]>(url, { size, page, filter });
  }
}
